/* The shop's own details.
 *
 * There is no id in the path: a session names one organisation, and the server
 * takes it off the token rather than off the request. Reading is anyone signed
 * in; changing is the office, which the server answers 403 to anyone else, so
 * nothing here needs to ask. */
import type { OrganisationDto, UpdateOrganisationRequest } from '@oneshot2pac/shared';
import { api } from './client';

export const organisationApi = {
  get: () => api.get<OrganisationDto>('/organisation'),

  /** Send only what changed. A blank ABN clears it. */
  update: (body: UpdateOrganisationRequest) => api.patch<OrganisationDto>('/organisation', body),
};
